import { BadgeOption } from 'src/types';
import { PAYMENT_METHOD_TYPE } from 'src/features/paymentMethods/utils/types';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export const PAYMENT_TYPE_METHODS_BADGE_OPTIONS: Record<PAYMENT_METHOD_TYPE, BadgeOption> = {
    [PAYMENT_METHOD_TYPE.CASH]: {
        label: moneyAccountsMessages.cash,
        theme: 'green',
        icon: ICON_MAP.CASH,
    },
    [PAYMENT_METHOD_TYPE.CARD]: {
        label: moneyAccountsMessages.card,
        theme: 'yellow',
        icon: ICON_MAP.CARD,
    },
    [PAYMENT_METHOD_TYPE.BANK]: {
        label: moneyAccountsMessages.bank,
        theme: 'blue',
        icon: ICON_MAP.BANK,
    },
};

export const PAYMENT_TYPE_METHODS_TRANSLATION_MAP: Record<PAYMENT_METHOD_TYPE, { id: string; defaultMessage: string }> =
    {
        [PAYMENT_METHOD_TYPE.CASH]: moneyAccountsMessages.cash,
        [PAYMENT_METHOD_TYPE.CARD]: moneyAccountsMessages.card,
        [PAYMENT_METHOD_TYPE.BANK]: moneyAccountsMessages.bank,
    };
